import styled from "styled-components";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0;
	@media (min-width: 900px) {
		padding: 0 1rem;
	}
`;

export default Page;